import {useIntl} from 'react-intl'

interface UploadAreaProps {
  disabled?: boolean
  isDragging: boolean
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void
  onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void
  onUploadClick: () => void
  fileInputRef: React.RefObject<HTMLInputElement>
  onFileSelect: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function UploadArea({
  disabled = false,
  isDragging,
  onDragOver,
  onDragLeave,
  onDrop,
  onUploadClick,
  fileInputRef,
  onFileSelect,
}: UploadAreaProps) {
  const intl = useIntl()

  return (
    <div
      className={`gori-signature-upload-area text-center ${isDragging ? 'dragging' : ''} ${
        disabled ? 'disabled' : ''
      }`}
      onDragOver={disabled ? undefined : onDragOver}
      onDragLeave={disabled ? undefined : onDragLeave}
      onDrop={disabled ? undefined : onDrop}
      role='button'
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault()
          onUploadClick()
        }
      }}
      aria-label={intl.formatMessage({id: 'GORI_SIGNATURE_DRAG_DROP'})}
      aria-disabled={disabled}
    >
      <div className='gori-signature-upload-icon mb-4'>
        <i className='bi bi-camera'></i>
      </div>

      <p className='fs-3 text-white mb-4'>
        {intl.formatMessage({id: 'GORI_SIGNATURE_DRAG_DROP'})}
        <br />
        {intl.formatMessage({id: 'GORI_SIGNATURE_OR'})}
      </p>

      <button
        className='gori-signature-submit btn btn-outline btn-primary-deep hover-orange rounded-pill'
        onClick={onUploadClick}
        disabled={disabled}
        aria-label={intl.formatMessage({id: 'GORI_SIGNATURE_UPLOAD_PHOTO'})}
      >
        {intl.formatMessage({id: 'GORI_SIGNATURE_UPLOAD_PHOTO'})}
      </button>

      <input
        ref={fileInputRef}
        type='file'
        accept='image/*,.pdf'
        capture='environment'
        onChange={onFileSelect}
        disabled={disabled}
        className='d-none'
      />
    </div>
  )
}

UploadArea.displayName = 'UploadArea'
